import { render, staticRenderFns } from "./categoryEdit.vue?vue&type=template&id=7a137ef4&"
import script from "./categoryEdit.vue?vue&type=script&lang=js&"
export * from "./categoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./categoryEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports